import { useShowNotificationOnError as coreUseShowNotificationOnError } from 'accelerator-common/lib/useShowNotificationOnError';
import type { ResourceId } from 'owa-localize';

export const useShowNotificationOnError: (
    error: unknown,
    messageTextResourceId: ResourceId,
    messageIconName?: string | undefined,
    actionTextResourceId?: ResourceId | undefined,
    actionCallback?: (() => void) | undefined
) => void = coreUseShowNotificationOnError.bind(null, 'HybridspaceNotificationBarHost');
